module.exports = __webpack_public_path__ + "static/media/github-white.8e652aec.svg";